import { render, staticRenderFns } from "./InventoryReport.vue?vue&type=template&id=ed784d06&scoped=true"
import script from "./InventoryReport.vue?vue&type=script&lang=ts"
export * from "./InventoryReport.vue?vue&type=script&lang=ts"
import style0 from "./InventoryReport.vue?vue&type=style&index=0&id=ed784d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed784d06",
  null
  
)

export default component.exports